import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import Notify from '@/components/Notification';
import { loanService } from '../../services/loanService';

export const useApplyForRefin = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload =>
      loanService.refinApply(payload).then(response => {
        const { status, data } = response;
        queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.loan.list] });
        if (status === 200) {
          return data;
        }

        if (status === 406) {
          Notify.error({ text: data?.message });
        }
      }),
  });
};
